import { render, staticRenderFns } from "./UserRoleBadge.vue?vue&type=template&id=74ad0880&scoped=true&"
import script from "./UserRoleBadge.vue?vue&type=script&lang=ts&"
export * from "./UserRoleBadge.vue?vue&type=script&lang=ts&"
import style0 from "./UserRoleBadge.vue?vue&type=style&index=0&id=74ad0880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ad0880",
  null
  
)

export default component.exports